<template>
    <InputRangeTwoKnobbedWithInputsContainer>
        <InputRangeTwoKnobbedExponentialOk
            v-bind="props"
            v-model="model"
        />
        <InputRangeTextInputs
            v-model="textModel"
            :min="bounds.min"
            :max="bounds.max"
            :value-formatter="valueFormatter"
            :max-label="maxLabel"
            :min-label="minLabel"
        />
    </InputRangeTwoKnobbedWithInputsContainer>
</template>

<script lang="ts" setup>
import { useModel } from 'vue'
import InputRangeTextInputs from '@/components/ui/inputs/range/InputRangeTextInputs.vue'
import InputRangeTwoKnobbedWithInputsContainer from '@/components/ui/inputs/range/InputRangeTwoKnobbedWithInputsContainer.vue'
import {
    defaults,
    type Props,
} from '@/components/ui/inputs/range/input-range-exponential-ok-props.ts'
import InputRangeTwoKnobbedExponentialOk from '@/components/ui/inputs/range/InputRangeTwoKnobbedExponentialOk.vue'
import { useSliderModel } from '@/composables/exponential-slider.ts'

const props = withDefaults(defineProps<Props>(), defaults)

const model = useModel(props, 'modelValue')

const textModel = useSliderModel(model, () => props.bounds)
</script>
